import { useDispatch, useSelector } from 'react-redux';
import { getIsAuthenticatedUserAnInstitute } from 'logic/store/authentication/authentication.selectors';
import { navigationSlice } from 'logic/store/navigation/navigation.slice';
import { AppRoute } from 'app/app.route.const';
import { useLayoutEffect } from 'react';

export const useRedirectIfNotTI = (path: string = AppRoute.Home) => {
  const dispatch = useDispatch();
  const isTI = useSelector(getIsAuthenticatedUserAnInstitute);

  useLayoutEffect(() => {
    if (!isTI) {
      dispatch(
        navigationSlice.actions.navigateTo({
          path,
        })
      );
    }
  }, [dispatch, isTI, path]);
};

export const useRedirectIfNotRegularUser = (path: string = AppRoute.Home) => {
  const dispatch = useDispatch();
  const isTI = useSelector(getIsAuthenticatedUserAnInstitute);

  useLayoutEffect(() => {
    if (isTI) {
      dispatch(
        navigationSlice.actions.navigateTo({
          path,
        })
      );
    }
  }, [dispatch, isTI, path]);
};
